//////////////////////////////////
////////// Open a dialouge box
//////////////////////////////////

  $( function() {
    $( "#dialog" ).dialog({
      autoOpen: false,
    });
 
    $( "#opener" ).on( "click", function() {
      $( "#dialog" ).dialog( "open" );
    });
  } );
  		
        
////////////////////////////////////////////////
////////// Testimonial slider on dialouge box
////////////////////////////////////////////////
        
        
       $(document).ready(function(){ 
          $('.custom_icb_slider').slick({
            dots: false,
            infinite: true,
            arrows: true
          });
         });
  
/*
    $(document).ready(function(){ 
  $( function() {
    $( "#customr50" ).datepicker();
  } );
      });
      
*/      
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}